import React, {Fragment} from 'react';
import Contactpage from './Contactpage';

const Contact =() => {
    return(
        <Fragment>
            <Contactpage/>
        </Fragment>
    )
};
export default Contact;

